import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import IconButton from "@mui/material/IconButton";
import { ThemeProvider } from "@mui/material/styles";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import ProductManageDialog from "@/components/productManageDialog";
import Title from "@/components/title";
import { ProductManageTableColumn } from "@/config/tableColumnConfig";

// Mui Icon
import { AddOutlined } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Fetch
import {
  exportToXls,
  getBrandtype,
  getProductCategories,
  getProducts,
} from "@/fetch/fetchProduct";
import { useCurrentAction } from "@/hooks/user";
import { useGridApiRef } from "@mui/x-data-grid";

const ProductManagePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  const apiRef = useGridApiRef();

  // Navigate
  const navigate = useNavigate();

  // States
  const [categoriesOption, setCategoriesOption] = React.useState([]);
  const [productData, setProductData] = React.useState([]);
  const [brand, setBrand] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const initial = {
    m18_product_code: null,
    brand_types_id: null,
    mannings_product_code: null,
    product_name: null,
    product_unit_price: null,
    is_active: true,
    region_id: 1,
    muti_region: false,
    type: [],
    categories: [],
  };
  const [editData, setEditData] = React.useState(initial);

  const handleAddClick = () => {
    setEditData(initial);
    setDialogOpen((prev) => !prev);
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      const { data } = await getProductCategories();
      if (data.categories) {
        setCategoriesOption(data.categories);
      }
      await getProducts(true).then((data) => {
        if (data && data.results) {
          setProductData(data.data);
        } else {
          setProductData([]);
        }
      });
      const { data: brand } = await getBrandtype();
      setBrand(brand);
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };
  const handleDownload = async () => {
    await exportToXls(moment().format("YYYY-MM-DD"), 1, true).then(
      (response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Product List.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
    );
  };
  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  const handleOnChange = (field, value) => {
    setEditData((prev) => {
      return {
        ...prev,
        [field]: value,
      };
    });
  };
  const getRowId = (row) => {
    return row.id;
  };
  const handleOnSuccess = (data) => {
    setSnackSeverity("success");
    setSnackMessage("新增／更新成功");
    setSnackOpen(true);
    apiRef.current.updateRows([{ ...data }]);
  };
  const handleOnFailed = () => {
    setSnackSeverity("error");
    setSnackMessage("新增／更新失敗");
    setSnackOpen(true);
  };
  React.useEffect(() => {
    fetchAll();

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      selectedIndex={15}
      snackSeverity={snackSeverity}
      header="productManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="產品管理"
        history={() => navigate(-1)}
        children={
          <div>
            {/* Add Record */}
            {actions?.create && (
              <IconButton component="label" onClick={() => handleAddClick()}>
                <AddOutlined />
              </IconButton>
            )}
            {actions?.download && (
              <IconButton component="label" onClick={() => handleDownload()}>
                <DownloadIcon />
              </IconButton>
            )}
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <ProductManageDialog
          {...{
            brand,
            dialogOpen,
            setDialogOpen,
            fetchAll,
            editData,
            handleOnChange,
            actions,
            handleOnSuccess,
            handleOnFailed,
            productData,
            categoriesOption,
          }}
        />
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            getRowId={getRowId}
            apiRef={apiRef}
            loading={dataTableLoading}
            rows={productData}
            columns={ProductManageTableColumn(brand)}
            pageSize={100}
            onCellClick={(data) => {
              setDialogOpen(true);
              setEditData(data.row);
            }}
            initialState={{
              sorting: {
                sortModel: [{ field: "is_active", sort: "desc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default ProductManagePage;
